import { render, staticRenderFns } from "./CustomerAnalysisMatrix.vue?vue&type=template&id=ce9381a2&scoped=true"
import script from "./CustomerAnalysisMatrix.vue?vue&type=script&lang=js"
export * from "./CustomerAnalysisMatrix.vue?vue&type=script&lang=js"
import style0 from "./CustomerAnalysisMatrix.vue?vue&type=style&index=0&id=ce9381a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9381a2",
  null
  
)

export default component.exports